import React, { Component } from 'react';
import { connect } from 'react-redux';
import { startRedirect } from '../../actions';
import { withRouter } from 'react-router-dom';

class Four0Four extends Component {

  componentWillMount() {
    this.props.startRedirect("https://dealmachineapp.com");
  }

  render(){
    return (
      <div />
    );
  }

};


export default withRouter(connect(null, { startRedirect })(Four0Four));



// WEBPACK FOOTER //
// ./src/components/Four0Four/index.js